import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import type {
	IAppWillMountHandler,
	ISiteServicesProvider,
	ServiceProvider } from '@wix/thunderbolt-symbols'
import {
	ServiceProviderSymbol,
} from '@wix/thunderbolt-symbols'

export const SiteServicesProvider = withDependencies(
	[multi(ServiceProviderSymbol)],
	(siteServiceProviders: Array<ServiceProvider>): ISiteServicesProvider & IAppWillMountHandler => {
		return {
			get: () => siteServiceProviders,
			appWillMount: async () => {},
		}
	}
)
